import React, {Ref} from 'react';
import {Box} from '@material-ui/core';
import {Column, UseFiltersColumnOptions, UseSortByColumnOptions} from 'react-table';

import {
    School, SearchRequest, SearchResponse
} from '../../api/types';
import {VStack} from '../layout/layout.styled';
import {LoadingView} from '../loading/loading';
import {
    PaginationOptions,
    SchoolAcademicYearTable,
    TableRef,
    SearchControls,
    FilterItem,
    FilterMenu
} from './components';

export type AcademicYearSearchFormProps = {
    onSearch: (options: SearchRequest) => any
    onSetSettingFilter: (setting: string) => any
    onSetRegionFilter: (region: string) => any
    onPaginationChange: (options: PaginationOptions) => any
    pageSize: number
    pageIndex: number
    data?: SearchResponse
    tableRef: Ref<TableRef>
    columns: SchoolAcademicYearTableColumn[]
    regions: Array<FilterItem>
    isVisible?: boolean
    isError: boolean
    isLoading: boolean
    isPreviousData: boolean
    isFetching: boolean
}

export type SchoolAcademicYearTableColumn =
    & Column<School>
    & UseSortByColumnOptions<School>
    & UseFiltersColumnOptions<School>

export const AcademicYearSearchForm = ({
    isVisible = true,
    data,
    onSearch,
    isLoading,
    isFetching,
    isPreviousData,
    isError,
    tableRef,
    columns,
    regions,
    onSetSettingFilter,
    onSetRegionFilter,
    onPaginationChange,
    pageSize,
    pageIndex
}: AcademicYearSearchFormProps) => {
    return (
        <Box data-testid={'SchoolAcademicYearTable'}>
            <VStack
                spacing={'20px'}
                justifyContent={'flex-start'}
            >
                <SearchControls
                    isLoading={isLoading}
                    onSearch={onSearch}
                />

                <FilterMenu
                    regionMenuItems={regions}
                    onSetRegionFilter={onSetRegionFilter}
                    onSetSettingFilter={onSetSettingFilter}
                />

                {isLoading ? <LoadingView/> : null}

                {data && isVisible && !isLoading ?
                    <SchoolAcademicYearTable
                        isPreviousData={isPreviousData}
                        isFetching={isFetching}
                        totalPages={data?.totalResultPages ?? 1}
                        totalSchoolsFound={data?.totalSchoolsFound ?? 0}
                        isError={isError}
                        columns={columns}
                        data={data?.schools || []}
                        ref={tableRef}
                        pageSize={pageSize}
                        pageIndex={pageIndex}
                        onPaginationChange={onPaginationChange}
                    /> : null}
            </VStack>
        </Box>
    );
};
